import { map, omit, concat, filter } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_AUTHORIZED, SET_STATUSES, ADD_STATUS } from 'vx/mutations'

const initialStatusState = () => {
  return {
    id: null,
    name: null,
    project_stage_id: null,
    parent_id: null
  }
}

// User state.
const state = {
  status: initialStatusState(),
  statuses: []
}

// User state getters.
const getters = {

  getById: (state) => (id) => {
    return state.statuses.find(item => {
      return item.id == id;
    })
  },

  /**
   * User state as a decorated object.
   */
  statuses: state => state.statuses,

  /**
   * User options for drop down.
   */

  stage1List: state => state.statuses.filter(status => status.project_stage_id == 1).map(status => ({ id: status.id, name: status.name })),
  stage2List: state => state.statuses.filter(status => status.project_stage_id == 2).map(status => ({ id: status.id, name: status.name })),
  stage3List: state => state.statuses.filter(status => status.project_stage_id == 3).map(status => ({ id: status.id, name: status.name }))
}

// User actions.
const actions = {

  /**
   * Get a list of users.
   */
  getStatuses ({ commit }, payload) {
    return http.get(`projects/statuses-list?${queryString(payload)}`).then(response => {
      commit(SET_STATUSES, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {

  /**
  * Set the users state.
  */
  [SET_STATUSES] (state, statuses) {
    state.statuses = statuses
  },

  /**
   * Add more users to the users state.
   */
  [ADD_STATUS] (state, statuses) {
    state.statuses = concat(state.statuses, statuses)
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
